import { createVuetify } from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VBtn, VDataTable, VOtpInput } from 'vuetify/components'
import { md3 } from 'vuetify/blueprints'
import { uk } from './i18n'
import { bestIcons, iconSetFabric } from 'best-modules/icons'
import { intimeIcons } from '@/icons/intime'
import { mdiLightIcons } from '@/icons/mdi-light'

const vuetify = createVuetify({
  components: {
    VDataTable,
    VOtpInput,
  },
  locale: {
    locale: 'uk',
    fallback: 'en',
    messages: { uk },
  },
  blueprint: md3,
  aliases: {
    VBtnAlt: VBtn,
    VBtnLink: VBtn,
  },
  icons: {
    defaultSet: 'mdi',
    sets: {
      best: iconSetFabric(bestIcons),
      intime: iconSetFabric(intimeIcons),
      'mdi-light': iconSetFabric(mdiLightIcons),
    },
  },
  defaults: {
    VDataTable: {
      density: 'comfortable',
      rounded: 'lg',
    },
    VTextField: {
      color: '#e8e8ed',
      bgColor: '#fff',
      variant: 'outlined',
      density: 'compact',
      rounded: 'lg',
    },
    VTextarea: {
      bgColor: '#fff5',
      variant: 'outlined',
      density: 'compact',
      rounded: 'lg',
    },
    VCheckbox: {
      color: 'primary',
      density: 'compact',
    },
    VSelect: {
      menuIcon: 'mdi-chevron-down',
      color: '#000000',
      bgColor: '#fff',
      variant: 'outlined',
      density: 'compact',
      rounded: 'lg',
    },
    VAutocomplete: {
      menuIcon: 'mdi-chevron-down',
      color: '#000000',
      bgColor: '#fff',
      variant: 'outlined',
      density: 'compact',
      rounded: 'lg',
    },
    VBtn: {
      color: 'primary',
      rounded: 'lg',
      variant: 'flat',
    },
    VBtnAlt: {
      color: 'primary',
      border: true,
      rounded: 'lg',
    },
    VListItem: {
      minHeight: '40px',
    },
    VBtnLink: {
      color: 'secondary',
      variant: 'plain',
      density: 'compact',
      elevation: '0',
      class: ['link'],
    },
    VChip: {
      density: 'compact',
      rounded: 'pill',
      size: 'small',
      variant: 'tonal',
    },
    VToolbar: {
      color: 'white',
      elevation: 0,
      density: 'comfortable',
    },
    VTooltip: {
      location: 'bottom',
    },
    VTab: {
      rounded: false,
    },
    VList: {
      class: 'bg-white',
      border: true,
      elevation: 1,
    },
    VOverlay: {
      border: true,
      elevation: 1,
    },
    VMenu: {
      offset: 8,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          surface: '#F4F4F5',
          primary: '#1a1a1b',
          secondary: '#185fa5',
          info: '#185fa5',
          success: '#1a7a4a',
          warning: '#c07a00',
          error: '#c0392b',
          darkGrey: '#d7d7d8',
          'light-blue': '#e6f1fb',
          'surface-border': '#e8e8ed',
        },
      },
      sso: {
        dark: false,
        colors: {
          background: '#f3f5f8',
          surface: '#ffffff',
          'surface-variant': '#f3f5f8',
          primary: '#1f4fb5',
          'on-primary': '#ffffff',
          'primary-darken-1': '#183f92',
          secondary: '#1a1a1b',
          'on-secondary': '#ffffff',
          success: '#1a7a4a',
          warning: '#c07a00',
          error: '#b42318',
          'surface-border': '#c9d0da',
          'text-primary': '#1a2230',
          'text-muted': '#566072',
        },
      },
    },
  },
  display: {
    mobileBreakpoint: 'sm',
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

export default vuetify
